export const popularBrandsConfig = [
    { id: "1", name: "LADA (ВАЗ)", alias: "lada-vaz" },
    { id: "2", name: "Toyota", alias: "toyota" },
    { id: "3", name: "Kia", alias: "kia" },
    { id: "4", name: "Hyundai", alias: "hyundai" },
    { id: "5", name: "Nissan", alias: "nissan" },
    { id: "6", name: "Volkswagen", alias: "volkswagen" },
    { id: "7", name: "BMW", alias: "bmw" },
    { id: "8", name: "Mercedes-Benz", alias: "mercedesbenz" }
];